import React from 'react';
import { CurrencySelector } from '../../_components';
import { CompanyInfo } from './CompanyInfo';
import { currencyTypeConstants } from '../../_constants'
import { currencyServices , transactionService } from '../../_services'
import { connect } from 'react-redux';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

class DepositHWGCashForm extends React.Component {

    constructor(props){
        super(props); 
        
        this.state = {
            method : 'bitcoin' , 
            btcRate : 0
        }

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.ticker != this.props.ticker && nextProps.ticker.tickerinfo){

            (nextProps.ticker.tickerinfo.length > 0 ) && 
            nextProps.ticker.tickerinfo.map((item) => {
                if(item.symbol === 'BTC'){
                    this.setState({
                        btcRate : item.price_usd
                    })
                } 
            })
        }
    }

    handleMethodChange (event){
        this.setState({
            method : event.target.value
        })
    }

    handleSubmit(event){
        event.preventDefault();
        
        const {blockChainTxId , currency , amount , file , currencyType , isHWGCash , authentication } = this.props; 

        if(currencyType === currencyTypeConstants.CURRENCYTYPE_CASH && this.state.method === "tt"){
            //make sure file is not empty for cash transfer 
            if(!file){
                
                Alert.error(`Please upload proof of transaction slip to proceed`, {
                    position: 'bottom-right' , 
                    effect : 'flip'
                });

                return false;
            }
        }
        
        let formBody = {
            blockChainTxId : blockChainTxId, 
            currency : currency , 
            amount : amount , 
            exchangeRate : this.state.btcRate , 
            exchangeCurrency : 'BTCUSD' , 
            memberId : authentication.user.id
        }; 

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberDeposit(formBody , file);
    }

    render (){
        const { handleCurrencyDropdown , handleChange , handleUploadFile
            , currencies , currency , currencyType , settings ,
            amount , filename , image , disableSubmit , blockChainTxId } = this.props ; 

        const {method , btcRate} = this.state;

        return (
            
            <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                <h4>Get HWG Cash</h4>

                <div className="has-instruction">
                    1. HWG Cash amount
                </div>

                <div className="field is-horizontal m-t-md">
                    <div className="field-label is-small">
                        <label className="label">Stable Token</label>
                    </div>
                    <div className="field-body">
                        <CurrencySelector currencies={currencies} currency={currency} 
                                        handleChange={handleCurrencyDropdown} defaultText='Select deposit currency'/>
                        
                    </div>
                </div>

                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label">Amount</label>
                    </div>
                    <div className="field-body">
                        <input className="input is-small" onChange={handleChange} name="amount" value={amount} type="text" placeholder="Amount of HWG Cash" 
                            required
                        />
                    </div>
                </div>

                <div className="has-instruction">
                    2. Bank Details
                </div>

                <div className='form-info m-b-md'>
                {
                    (settings.length > 0) && 
                    <React.Fragment>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Bank Name</label>
                            </div>
                            <div className="field-body">{
                                settings.find((obj) => { 
                                    return obj.lookupName === 'BANK_NAME'
                                }).lookupValue
                            }</div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Account Name</label>
                            </div>
                            <div className="field-body">{
                                settings.find((obj) => { 
                                    return obj.lookupName === 'BANK_ACC_NAME'
                                }).lookupValue
                            }</div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Account Type</label>
                            </div>
                            <div className="field-body">{
                                settings.find((obj) => { 
                                    return obj.lookupName === 'HWGCASH_BANK_ACC_TYPE'
                                }).lookupValue
                            }</div>
                        </div>
                        <div className="field is-horizontal">
                            <div className="field-label is-small">
                                <label className="label">Account Number</label>
                            </div>
                            <div className="field-body">{
                                settings.find((obj) => { 
                                    return obj.lookupName === 'HWGCASH_BANK_ACC_NUM'
                                }).lookupValue
                            }</div>
                        </div>
                    </React.Fragment>
                }
                </div>
                
                {
                    (currencyType === currencyTypeConstants.CURRENCYTYPE_DIGITAL_ASSET) &&    
                    <div className="field is-horizontal">
                        <div className="field-label is-small ">
                            <label className="label">Transaction ID</label>
                        </div>
                        <div className="field-body">
                            <input className="input is-small" value={blockChainTxId} name="blockChainTxId" onChange={handleChange} type="text" placeholder={`${currency} Transaction Reference`} />
                        </div>
                    </div>
                }
                
                <div className="has-instruction">
                    3. Payment Method
                </div>
                
                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label">Method</label>
                    </div>
                    <div className="field-body">
                    
                        <div className="select is-fullwidth">
                            <select value={method} onChange={this.handleMethodChange}>
                                <option value="bitcoin">Bitcoin</option>
                                <option value="tt">TT Transfer</option>
                            </select>
                        </div>  
                    </div>
                </div>
                
                {
                    method === 'bitcoin' ? (
                        <React.Fragment>
                            <div className='form-info m-b-md'>
                                {/* hardcode btc company info for hwg cash payment method */}
                                <CompanyInfo settings = {settings} currencyType={currencyTypeConstants.CURRENCYTYPE_DIGITAL_ASSET} currency='BTC'/>
                            </div>
                            <div className="field is-horizontal">
                                <div className="field-label is-small ">
                                    <label className="label">Transaction ID</label>
                                </div>
                                <div className="field-body">
                                    <input className="input is-small" value={blockChainTxId} name="blockChainTxId" onChange={handleChange} type="text" placeholder={`${currency} Transaction Reference`} />
                                </div>
                            </div>
                            <div className="field is-horizontal">
                                <div className="field-label is-small ">
                                    <label className="label">Current BTC</label>
                                </div>
                                <div className="field-body">
                                    <span>USD {btcRate} (We will record this rate for this transaction)</span>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                    : (
                        <React.Fragment>
                            <div className='form-info m-b-md'>
                                {/* hardcode btc company info for hwg cash payment method */}
                                <CompanyInfo settings = {settings} currencyType={currencyTypeConstants.CURRENCYTYPE_CASH} currency='USD'/>
                            </div>

                            <div className="has-instruction">
                                4. Proof of Transaction
                            </div>

                            <div className="field is-horizontal">
                                <div className="field-label is-small">
                                    <label className="label">Upload Slip</label>
                                </div>
                                <div className="field-body">
                                    <div className="file has-name is-right">
                                        <label className="file-label">
                                            <input onChange={handleUploadFile} className="file-input" type="file" name="filename" />
                                            <span className="file-cta ">
                                                <span className="file-icon">
                                                    <i className="fas fa-upload"></i>
                                                </span>
                                                <span className="file-label">
                                                    Choose a file…
                                                </span>
                                            </span>
                                            <span className="file-name">
                                                {filename}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="field is-horizontal">
                                <div className="field-label is-small">
                                    <label className="label"></label>
                                </div>
                                <div className="field-body">
                                    <img src={image} className="holder-upload-image"/>
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }
                
                
                <div className="control m-t-lg is-pulled-right">
                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Purchase"/>
                </div>
            </form>
        )
    }
}

function mapStateToProps(state) {
    const { ticker } = state;
    return {
        ticker
    };
}

const connected = connect(mapStateToProps)(DepositHWGCashForm);
export { connected as DepositHWGCashForm }; 



// WEBPACK FOOTER //
// ./src/Views/DepositPage/DepositHWGCashForm.jsx